[
  {
    "id": "SR-E8P-PYJAMABROEK-V01",
    "module": "SpellingRegel",
    "difficulty": 306,
    "difficultyTier": 18,
    "levelCode": "E8+",
    "group": 8,
    "skill": "schrijfwijze",
    "subSkill": "samenstelling",
    "familyId": "SR-SAMENSTELLING-WEETWOORD",
    "conceptId": "compound_with_loanword",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["pyjamabroek", "pijamabroek", "pyamabroek", "pyjama-broek"],
    "correctAnswer": 0,
    "explanation": "'Pyjamabroek' is een samenstelling: pyjama + broek. 'Pyjama' schrijf je met 'y' en 'j'. Samenstellingen schrijf je aan elkaar.",
    "distractorExplanations": {
      "1": "Het is 'py', niet 'pi'. De 'y' is essentieel in 'pyjama'.",
      "2": "De 'j' ontbreekt. Het is py-ja-ma, niet py-a-ma.",
      "3": "Samenstellingen schrijf je aan elkaar, zonder streepje."
    }
  },
  {
    "id": "SR-E8P-PER-SE-V01",
    "module": "SpellingRegel",
    "difficulty": 306,
    "difficultyTier": 18,
    "levelCode": "E8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-PER-SE",
    "conceptId": "latin_loanword_two_words",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["per se", "persé", "persee", "perse"],
    "correctAnswer": 0,
    "explanation": "'Per se' zijn twee woorden. Geen accent nodig in de nieuwe spelling. Het is Latijn en betekent 'per definitie' of 'absoluut'.",
    "distractorExplanations": {
      "1": "Het accent is niet meer nodig. En het zijn twee woorden, niet één.",
      "2": "Geen dubbele 'e'. Het zijn twee losse woorden: per se.",
      "3": "Het zijn twee woorden, niet één. Per se."
    }
  },
  {
    "id": "SR-E8P-KANGOEROE-V01",
    "module": "SpellingRegel",
    "difficulty": 306,
    "difficultyTier": 18,
    "levelCode": "E8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-KANGOEROE",
    "conceptId": "tricky_vowel_endings",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["kangoeroe", "kangeroe", "kangoero", "kangroe"],
    "correctAnswer": 0,
    "explanation": "'Kangoeroe' heeft twee keer 'oe': kang-oe-r-oe. Het eindigt op '-oe'. Dit is een lastig weetwoord vanwege de herhaalde 'oe'-klank.",
    "distractorExplanations": {
      "1": "Hier ontbreekt de eerste 'oe'. Het woord heeft twee keer 'oe': kang-oe-r-oe.",
      "2": "Het eindigt op '-oe', niet op '-o'.",
      "3": "Er missen meerdere letters. Het is kang-oe-roe."
    }
  },
  {
    "id": "SR-E8P-PORTEMONNEE-V01",
    "module": "SpellingRegel",
    "difficulty": 306,
    "difficultyTier": 18,
    "levelCode": "E8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-PORTEMONNEE",
    "conceptId": "french_loanword_spelling",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["portemonnee", "portemonee", "portomonee", "portemonne"],
    "correctAnswer": 0,
    "explanation": "'Portemonnee' is de vernederlandste spelling. Dubbele 'n' en dubbele 'e'. Onthoud: porte-mon-nee.",
    "distractorExplanations": {
      "1": "Hier ontbreekt een 'n'. Het woord heeft dubbel-n: porte-mon-nee.",
      "2": "De eerste lettergreep is 'porte', niet 'porto'. En er ontbreekt een 'n'.",
      "3": "Hier ontbreekt een 'e'. Het woord eindigt op dubbel-e: portemon-nee."
    }
  },
  {
    "id": "SR-E8P-ACCOMMODATIE-V01",
    "module": "SpellingRegel",
    "difficulty": 306,
    "difficultyTier": 18,
    "levelCode": "E8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-ACCOMMODATIE",
    "conceptId": "tricky_double_consonants",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["accommodatie", "accomodatie", "acommodatie", "acomodatie"],
    "correctAnswer": 0,
    "explanation": "'Accommodatie' heeft dubbele 'c' én dubbele 'm'. Onthoud: ac-com-mo-da-tie. Twee keer een dubbele medeklinker.",
    "distractorExplanations": {
      "1": "Hier ontbreekt een 'm'. Het woord heeft zowel dubbel-c als dubbel-m.",
      "2": "Hier ontbreekt een 'c'. Het woord begint met 'acc-', niet 'ac-'.",
      "3": "Hier ontbreken zowel een 'c' als een 'm'. Beide medeklinkers zijn dubbel."
    }
  }
]